export default __webpack_public_path__ + "static/media/landing-main.1097736f.png";